import { useMemo } from 'react';
import { apiClient } from '../api/apiClient';

// Backend calls scoped to one tenant/room. Mutations pass scalars as query params (matching the
// backend's [ApiController] parameter binding); reads return parsed data.
export function useRoomApi(tenant, room) {
  return useMemo(() => {
    const base = `/api/${tenant}/${room}`;
    return {
      getStatus: () => apiClient.get(`${base}/status`).then(r => r.data),
      getHistory: (kind, from, to) =>
        apiClient.get(`${base}/history`, { params: { kind, from, to } }).then(r => r.data),
      getConfig: () => apiClient.get(`${base}/config`).then(r => r.data),
      getDevices: () => apiClient.get(`${base}/devices`).then(r => r.data),
      getActivities: () => apiClient.get(`${base}/activities`).then(r => r.data),

      setDesiredTemperature: (temp) => apiClient.put(`${base}/temperature/desired`, null, { params: { temp } }),
      setStandbyTemperature: (temp) => apiClient.put(`${base}/temperature/standby`, null, { params: { temp } }),
      setPosition: (position) => apiClient.put(`${base}/heater`, null, { params: { position } }),
      setMode: (mode) => apiClient.put(`${base}/thermostat/mode`, null, { params: { mode } }),
      updateConfig: (config) => apiClient.put(`${base}/config`, config),
      setActivityTemperature: (name, temp) =>
        apiClient.put(`${base}/activities/${encodeURIComponent(name)}/temperature`, null, { params: { temp } }),
      clearActivityTemperature: (name) =>
        apiClient.delete(`${base}/activities/${encodeURIComponent(name)}/temperature`),

      // Device registry is global (/api/devices/...), not room-scoped: assigning binds a device to this
      // room by its numeric id (RoomConfig.roomId), and calibration is keyed by MAC.
      getUnassignedDevices: () => apiClient.get('/api/devices/unassigned').then(r => r.data),
      assignDevice: (mac, body) => apiClient.put(`/api/devices/${encodeURIComponent(mac)}/assign`, body),
      calibrateDevice: (mac, body) => apiClient.put(`/api/devices/${encodeURIComponent(mac)}/calibration`, body),
    };
  }, [tenant, room]);
}
